import Vue from 'vue'
import masterApiCall from '@/masteradmin/utils/api'
import { Notification } from 'element-ui'

import {
  ACTION_GET_APPLICATIONS,
} from '../actions'

import {
  MUTATION_SET_APPLICATIONS,
} from '../mutations'

const coursesModule = {
  state: {
    applications: [],
    itemTotal: 0,
    pageSize: 0,
    loading: false,
  },

  mutations: {
    [MUTATION_SET_APPLICATIONS](state, data) {
      const {
        applications, itemTotal, pageSize,
      } = data
      Vue.set(state, 'applications', applications)
      Vue.set(state, 'itemTotal', itemTotal)
      Vue.set(state, 'pageSize', pageSize)
    },

    setLoading(state, isLoading) {
      Vue.set(state, 'loading', isLoading)
    },
  },

  actions: {
    [ACTION_GET_APPLICATIONS]({ commit }, { page }) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        masterApiCall('get', `/masteradmin/applications?page=${page}`)
          .then(({ data }) => {
            commit(MUTATION_SET_APPLICATIONS, data)
            commit('setLoading', false)
            resolve()
          }, () => {
            Notification.error({
              title: 'Error!',
              message: 'Unable to retrieve applications list.',
              position: 'bottom-right',
            })
            commit('setLoading', false)
            reject()
          })
      })
    },
  },
}

export default coursesModule



// WEBPACK FOOTER //
// ./client/masteradmin/store/applicationsModule/index.js